import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import useTrashablePromises from "hooks/useTrashablePromises";
import { useIntl } from "react-intl";
import {
  IRegexValidationSaveRequest,
  RegexValidationSaveRequest,
} from "services/KnowfullyAdminClient";
import translateError from "utils/translateError";
import RegexValidationForm from "./RegexValidationForm";

type RegexValidationCreateFormProps = {
  onCreated: () => void;
  onCancel: () => void;
};

const RegexValidationCreateForm = ({
  onCreated,
  onCancel,
}: RegexValidationCreateFormProps) => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { licenseService } = useGlobalContext();

  const onSubmit = (values: IRegexValidationSaveRequest) =>
    registerPromise(
      licenseService.saveRegexValidation(
        new RegexValidationSaveRequest(values)
      )
    )
      .then(() => onCreated())
      .catch((err: any) => ({ [FORM_ERROR]: translateError(err, t) }));

  return (
    <RegexValidationForm
      onSubmit={onSubmit}
      title={t({ id: "regexValidationCreateTitle" })}
      submitLabel={t({ id: "saveButton" })}
      onCancel={onCancel}
    />
  );
};

export default RegexValidationCreateForm;
